import script from "./BlogDetailShare.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogDetailShare.vue?vue&type=script&lang=ts&setup=true"

import "./BlogDetailShare.vue?vue&type=style&index=0&id=03677fe0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03677fe0"]])

export default __exports__